/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type MobileNavSearchBar_viewer = {|
  +searchSuggestions?: ?{| |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "query",
      "type": "String!",
      "defaultValue": ""
    },
    {
      "kind": "LocalArgument",
      "name": "hasQuery",
      "type": "Boolean!",
      "defaultValue": false
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "MobileNavSearchBar_viewer",
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasQuery",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "includeTypes",
              "value": [
                "POPULAR",
                "SELLER"
              ],
              "type": "[String]"
            },
            {
              "kind": "Variable",
              "name": "query",
              "variableName": "query",
              "type": "String!"
            }
          ],
          "concreteType": "SearchSuggestion",
          "name": "searchSuggestions",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "MobileNavSearchResults_searchSuggestions",
              "args": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/MobileNav/MobileNavSearchBar/__generated__/MobileNavSearchBar_viewer.graphql.js